import { capitalizeFirst } from 'ramda-extension';

import { fragment as dietbet } from './dietbet';
import { fragment as stepbet } from './stepbet';

export { dietbet, stepbet };

const fragments = { dietbet, stepbet };

export const selectFragmentName = (gameType) =>
  `${capitalizeFirst(gameType)}ProfileFragment`;

export const selectFragment = (gameType) => fragments[gameType] || '';
